import type { DrawingRow, DrawingVersion, ProjectMember, ProjectSummary } from './types';

/**
 * 개발 미리보기(`?devshell=`) 전용 고정 데이터.
 *
 * DB 마이그레이션이 적용되기 전에도 화면을 만들고 검토할 수 있게 한다.
 * localhost 에서 devshell 모드일 때만 사용되며, 실제 조회 경로와 섞이지 않는다.
 */

const now = Date.now();
const iso = (daysAgo: number) => new Date(now - daysAgo * 86400000).toISOString();

export const FIXTURE_PROJECTS: ProjectSummary[] = [
  {
    id: 'p-0001',
    name: '수원점 1층 리뉴얼',
    project_type: 'renewal',
    status: 'active',
    store_code: 'S-101',
    store_name: '수원점',
    description: '신선 코너 확장 및 계산대 재배치',
    starts_on: null,
    ends_on: null,
    created_by: 'dev@localhost',
    created_at: iso(30),
    updated_at: iso(1),
    drawing_count: 4,
    my_role: 'owner',
    pending_review_count: 2,
  },
  {
    id: 'p-0002',
    name: '동탄 신규 출점',
    project_type: 'new_store',
    status: 'active',
    store_code: 'S-207',
    store_name: '동탄점',
    description: '지하 1층 · 지상 1층 신규 레이아웃',
    starts_on: null,
    ends_on: null,
    created_by: 'dev@localhost',
    created_at: iso(12),
    updated_at: iso(3),
    drawing_count: 7,
    my_role: 'designer',
    pending_review_count: 0,
  },
  {
    id: 'p-0003',
    name: '전점 냉장 쇼케이스 교체',
    project_type: 'equipment_change',
    status: 'on_hold',
    store_code: null,
    store_name: null,
    description: '2026년 3분기 노후 장비 교체',
    starts_on: null,
    ends_on: null,
    created_by: 'other@trial-net.co.kr',
    created_at: iso(60),
    updated_at: iso(20),
    drawing_count: 12,
    my_role: 'reviewer',
    pending_review_count: 1,
  },
];

function version(
  id: string,
  drawingId: string,
  n: number,
  status: DrawingVersion['status'],
  days: number
): DrawingVersion {
  return {
    id,
    drawing_id: drawingId,
    branch_id: `${drawingId}-main`,
    version_number: n,
    name: `v${n}`,
    change_summary: null,
    status,
    entity_count: 18420 + n * 137,
    created_by: 'dev@localhost',
    created_at: iso(days),
  };
}

export const FIXTURE_DRAWINGS: DrawingRow[] = [
  {
    id: 'd-1001',
    project_id: 'p-0001',
    name: '1F 현행 도면',
    drawing_type: 'floor_plan',
    floor_name: '1F',
    zone_tags: ['입구', '계산', '신선'],
    unit: 'mm',
    current_branch_id: 'd-1001-main',
    published_version_id: 'v-3',
    thumbnail_path: null,
    created_by: 'dev@localhost',
    created_at: iso(30),
    updated_at: iso(1),
    is_favorite: true,
    latest_version: version('v-3', 'd-1001', 3, 'published', 1),
  },
  {
    id: 'd-1002',
    project_id: 'p-0001',
    name: '1F 리뉴얼 A안',
    drawing_type: 'floor_plan',
    floor_name: '1F',
    zone_tags: ['신선', '행사'],
    unit: 'mm',
    current_branch_id: 'd-1002-main',
    published_version_id: null,
    thumbnail_path: null,
    created_by: 'dev@localhost',
    created_at: iso(9),
    updated_at: iso(1),
    is_favorite: true,
    latest_version: version('v-7', 'd-1002', 7, 'in_review', 1),
  },
  {
    id: 'd-1003',
    project_id: 'p-0001',
    name: '1F 리뉴얼 B안',
    drawing_type: 'floor_plan',
    floor_name: '1F',
    zone_tags: ['신선'],
    unit: 'mm',
    current_branch_id: 'd-1003-main',
    published_version_id: null,
    thumbnail_path: null,
    created_by: 'other@trial-net.co.kr',
    created_at: iso(6),
    updated_at: iso(2),
    is_favorite: false,
    latest_version: version('v-4', 'd-1003', 4, 'changes_requested', 2),
  },
  {
    id: 'd-1004',
    project_id: 'p-0001',
    name: '후방 창고 배치',
    drawing_type: 'floor_plan',
    floor_name: 'B1',
    zone_tags: ['창고', '후방'],
    unit: 'mm',
    current_branch_id: 'd-1004-main',
    published_version_id: null,
    thumbnail_path: null,
    created_by: 'dev@localhost',
    created_at: iso(5),
    updated_at: iso(5),
    is_favorite: false,
    latest_version: version('v-1', 'd-1004', 1, 'draft', 5),
  },
];

export const FIXTURE_MEMBERS: ProjectMember[] = [
  {
    project_id: 'p-0001',
    email: 'dev@localhost',
    role: 'owner',
    invited_by: null,
    created_at: iso(30),
  },
  {
    project_id: 'p-0001',
    email: 'other@trial-net.co.kr',
    role: 'designer',
    invited_by: 'dev@localhost',
    created_at: iso(28),
  },
  {
    project_id: 'p-0001',
    email: 'review@trial-net.co.kr',
    role: 'reviewer',
    invited_by: 'dev@localhost',
    created_at: iso(28),
  },
];
